import { render } from "./Readqr.vue?vue&type=template&id=95a990ac&scoped=true"
import script from "./Readqr.vue?vue&type=script&lang=js"
export * from "./Readqr.vue?vue&type=script&lang=js"

import "./Readqr.vue?vue&type=style&index=0&id=95a990ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95a990ac"

export default script